import { EventBaseSchema, eventType } from '@eigtech/event-stream-types';
import { z } from 'zod';
import { serviceName } from '../base/serviceName.js';
export const serviceEventType = (entity, eventName) => eventType(serviceName, entity, eventName);
export const ServiceEventBaseSchema = EventBaseSchema.merge(z.object({
    type: serviceEventType(),
}));
